import { BaseModel } from '@red/data-access';
import {  Expose } from 'class-transformer';
import { IMarital } from '../interfaces/marital.interface';


export class MaritalModel extends BaseModel implements IMarital {
  @Expose()
  id!: number;

  @Expose()
  code!: string;

  @Expose()
  name!: string;

  @Expose()
  status!: string;

  @Expose()
  createdAt!: string;

  @Expose()
  updatedAt!: string;
}
